/* ORIO Stripe loader — singleton (publishable key arriva da backend /payments/config) */
import { loadStripe } from "@stripe/stripe-js";

let _promise = null;
let _key = null;

export function getStripePromise(publishableKey) {
  if (!publishableKey) return null;
  if (_promise && _key === publishableKey) return _promise;
  _key = publishableKey;
  _promise = loadStripe(publishableKey);
  return _promise;
}

/* ORIO appearance — warm theme aligned with the rest of the app. */
export const ORIO_STRIPE_APPEARANCE = {
  theme: "flat",
  variables: {
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    colorPrimary: "#FF7A1A",
    colorBackground: "#FFFFFF",
    colorText: "#1A1A1A",
    colorTextSecondary: "#6B6B6B",
    colorDanger: "#E94545",
    borderRadius: "14px",
    spacingUnit: "4px",
    fontSizeBase: "15px",
  },
  rules: {
    ".Input": {
      backgroundColor: "#FBF7F1",
      border: "1px solid #F0EBE3",
      boxShadow: "none",
      padding: "12px 14px",
    },
    ".Input:focus": {
      border: "1px solid #FF7A1A",
      boxShadow: "0 0 0 3px rgba(255,122,26,0.18)",
    },
    ".Label": {
      color: "#6B6B6B",
      fontWeight: "500",
      fontSize: "12px",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    },
    ".Tab": {
      backgroundColor: "#FBF7F1",
      border: "1px solid #F0EBE3",
    },
    ".Tab--selected": {
      backgroundColor: "#FFF4E6",
      border: "1px solid #FF7A1A",
      color: "#FF7A1A",
    },
  },
};
